module.exports = __webpack_public_path__ + "img/1-11.b64d2cbc.png";